import http from "./http"
const attach = {
  downArticle(attachId) {
    return http.post("attach/downArticle?attachId=" + attachId, {}, { responseType: "blob" })
  },

  //下载用稿通知
  downNotice(articleId) {
    return http.post("attach/downNotice?articleId=" + articleId, {}, { responseType: "blob" })
  },

  //下载查重通知
  downDcFile(attachId) {
    return http.post("attach/downDcFile?attachId=" + attachId, {}, { responseType: "blob" })
  },

  //下载审核意见附件
  downAuditFile(attachId) {
    return http.post("attach/downAuditFile?attachId=" + attachId, {}, { responseType: "blob" })
  },

  //下载个人著作权许可书附件
  downPersonCopyright(attachId) {
    return http.post("attach/downMyCopyright?attachId=" + attachId, {}, { responseType: "blob" })
  },
}
export default attach
